
export default {
  name: "cal-skeleton-product-list",
};
